import React from 'react';
import { LawFirm } from '../../enterprise/enterprise.types';
import { EntityWithDecisionsToShow } from '../../entity/entity.types';
import { LawFirmList } from '../../entity/entity-lists/LawFirmList';
import { EntityModalLoader } from '../../components/entity-modal-placeholder/EntityModalLoader';
import { fetchEntrepriseLawFirms } from '../../enterprise/enterprise.api';
import {
  ModalScrollableHeader,
  ModalScrollableContent,
  ModalScrollableContainer,
} from '../../components/modal';
import { doctrineAnalytics } from '../../utils/analyticsUtils';
import { EntityDecisionListModalWithGoBack } from './EntityDecisionListModalWithGoBack';

type Props = {
  wording: string;
  siren: string;
  source: string;
  raisonSociale: string;
  onRequestClose: () => void;
  isOpen: boolean;
};

type State = {
  allLawFirms: Array<LawFirm>;
  isLoading: boolean;
  entityWithDecisionsToShowInfos: EntityWithDecisionsToShow | null;
};

export class AllLawFirmsModal extends React.Component<Props, State> {
  static defaultProps = {
    onRequestClose: () => {},
    isOpen: false,
  };

  state: State = {
    allLawFirms: [],
    isLoading: true,
    entityWithDecisionsToShowInfos: null,
  };

  async componentDidMount() {
    const { lawFirms: allLawFirms } = (
      await fetchEntrepriseLawFirms(this.props.siren, true)
    ).data;
    this.setState({ allLawFirms, isLoading: false });
  }

  handleClickDecision = (lawFirm: LawFirm) => {
    this.setState({
      entityWithDecisionsToShowInfos: {
        name: lawFirm.nom,
        params: {
          lawOfficeId: lawFirm.lawOfficeIdGroup,
          siren: this.props.siren,
        },
      },
    });
    doctrineAnalytics('Entity SeeEntityDecisions', {
      source: `${this.props.source}_modal`,
    });
  };

  handleGoBack = () => {
    this.setState({ entityWithDecisionsToShowInfos: null });
  };

  render() {
    const {
      raisonSociale,
      onRequestClose,
      source,
      wording,
      isOpen,
    } = this.props;
    const {
      isLoading,
      allLawFirms,
      entityWithDecisionsToShowInfos,
    } = this.state;
    return (
      <ModalScrollableContainer onRequestClose={onRequestClose} isOpen={isOpen}>
        {entityWithDecisionsToShowInfos ? (
          <EntityDecisionListModalWithGoBack
            entityWithDecisionsToShowInfos={entityWithDecisionsToShowInfos}
            wording={wording}
            closeModal={onRequestClose}
            handleGoBack={this.handleGoBack}
            source={source}
          />
        ) : (
          <>
            <ModalScrollableHeader
              title={`Cabinets ayant représenté ${raisonSociale}`}
              onClose={onRequestClose}
            />
            <ModalScrollableContent>
              <EntityModalLoader isLoading={isLoading}>
                <LawFirmList
                  lawFirms={allLawFirms}
                  source={`${source}_modal_list`}
                  wording={wording}
                  handleClickDecision={this.handleClickDecision}
                  fromModal
                />
              </EntityModalLoader>
            </ModalScrollableContent>
          </>
        )}
      </ModalScrollableContainer>
    );
  }
}
